// Components==============
import { useEvidence } from 'hooks/useEvidence';
import React, { createContext } from 'react';
import { evidenceCollectionType } from 'typings';
// =========================

type GlobalEvidenceContextType = evidenceCollectionType[];

export const GlobalEvidenceContext = createContext(
  {} as GlobalEvidenceContextType
);

export default function GlobalEvidence({
  children,
}: {
  children: React.ReactNode;
}) {
  const evidence = useEvidence();

  return (
    <GlobalEvidenceContext.Provider value={evidence}>
      {children}
    </GlobalEvidenceContext.Provider>
  );
}
